var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { login as loginReq } from "@/05-models/auth";
import { useErrorNotify } from "@/06-shared/lib/errorNotifier";
import { PopupButton, PopupInput, PopupWindow } from "@/06-shared/ui/popups";
import { useState } from "react";
export const Login = ({ isOpen, onSuccess, onClose }) => {
    const [login, setLogin] = useState("");
    const [password, setPassword] = useState("");
    const showError = useErrorNotify();
    const onLogin = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield loginReq({
                login: login,
                password: password
            });
            onSuccess();
        }
        catch (error) {
            showError(error);
        }
        finally {
            onClose();
        }
    });
    return (isOpen ? (_jsxs(PopupWindow, { name: "\u0412\u0445\u043E\u0434", onClose: () => { onClose(); }, children: [_jsx(PopupInput, { name: "\u041B\u043E\u0433\u0438\u043D", setInput: (data) => setLogin(data), autoFocus: true }), _jsx(PopupInput, { name: "\u041F\u0430\u0440\u043E\u043B\u044C", setInput: (data) => setPassword(data), onEnter: onLogin, autoFocus: false }), _jsx(PopupButton, { name: "[Ok]", onClick: () => onLogin() })] })) : null);
};
